import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvUserProfilePersistence = new MMKV({
  id: MMKVStoreKeyMap.userProfile,
});

export const zustandUserProfileStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvUserProfilePersistence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvUserProfilePersistence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvUserProfilePersistence.delete(name);
  },
};
